import { ErrorType } from "~/enums/ErrorType";
import { RegexHelper } from "~/helpers/regexHelper";
import ObjectModelProperty from "../objectModelProperties/objectModelProperty";
import ObjectModelRelation from "../objectModelRelations/objectModelRelation";
import ValidationError from "../validationError";
import NavigableValidator from "./navigableValidator";

export default class ReferenceableValidator extends NavigableValidator<ObjectModelProperty|ObjectModelRelation> {
  _validatorKey = 'reference_name';
  defaultMessage = "Must be unique and URL safe";
  defaultType = ErrorType.invalidValue;

  static isUrlSafe(value: string): boolean {
    return RegexHelper.urlSafe.test(value);
  }

  static isUnique(prop: ObjectModelProperty|ObjectModelRelation): boolean { 
    for (const property of prop.objectModel.objectModelPropertiesArray) {
      if (prop.id === property.id) continue;
      if (prop.reference_name === property.reference_name) return false;
    }

    for (const relation of prop.objectModel.objectModelRelationsArray) {
      if (prop.id === relation.id) continue;
      if (prop.reference_name === relation.reference_name) return false;
    }

    return true;
  }

  protected _validate(prop: ObjectModelProperty|ObjectModelRelation): void {
    if (!prop.reference_name) return;

    if (!ReferenceableValidator.isUrlSafe(prop.reference_name)) {
      this.errors.push(this.buildValidationError(prop, "Reference name must be url safe"));
    }

    if (!ReferenceableValidator.isUnique(prop)) {
      this.errors.push(this.buildValidationError(prop, "Reference name must be unique"));
    }
  }

  buildValidationError(prop: ObjectModelProperty|ObjectModelRelation, message?): ValidationError {
    const objectModel = prop.objectModel;
    const errorNavOpts = prop.validation.errorNavOpts(this, this.validatorKey);

    return new ValidationError({
      message: message || this.defaultMessage,
      displayName: `${prop.label_title}`,
      errorNavOpts: objectModel.validation.errorNavOpts(this, 'object_model_properties', objectModel),
      type: this.defaultType,
      section: this.section
    });
  }
}